import type { SxStyle } from '@aibees/shared/theme';
import type { Theme } from '@mui/material';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  width: 'fit-content',
};

export const wrapper: SxStyle = {
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: (p: Theme) => p.palette.grey[300],
  display: 'flex',
  borderRadius: 1,
  padding: (p) => p.spacing(0.25, 0.5),
};
